import React, { Component, Fragment } from "react";
import { findIndex, uniqBy } from "lodash";

import DesignTool from "./designtool";
import {
  ID_RING_TYPE_DEFAULT,
  RING_COLOR_DEFAULT,
  CHARM_TYPE,
  EARRINGS_TYPE_ID,
  MAX_WIDTH_SP,
  URL_IMG,
  URL_API, URL_SERVER,
  TYPE_NEXT_SAVE, URL_SERVER_UPT
} from './const'

import Header from "./components/Header";
import Menu from "./components/Menu";
import Content from "./components/Content";
import CartTotals from "./components/CartTotals";
import ButtonPurchase from "./components/Button/ButtonPurchase";
import ListMenu from "./components/Menu/ListMenu";
import MaterialsTray from "./components/MaterialsTray";

// Import Dialog
import DialogMessage from "./components/Dialog/DialogMessage";
import DialogConfirmSave from "./components/Dialog/DialogConfirmSave";
import DialogConfirmTab from "./components/Dialog/DialogConfirmTab";
import DialogConfirmKeepDesign from "./components/Dialog/DialogConfirmKeepDesign";

// Import modal
import ModalSelectSize from "./components/Modal/ModalSelectSize";
import ModalListDesign from "./components/Modal/ModalListDesign";
import ModalMaterial from "./components/Modal/ModalMaterial";
import ModalTutorial from "./components/Modal/ModalTutorial";
import ModalRingList from "./components/Modal/ModalRingList";
import ModalCategoryList from "./components/Modal/ModalCategoryList";
import ModalColorList from "./components/Modal/ModalColorList";
import ModalFortuneList from "./components/Modal/ModalFortuneList";
import ModalConfirmSelectNewStone from "./components/Modal/ModalConfirmSelectNewStone";
import ModalLimitDesign from "./components/Modal/ModalLimitDesign";
import ListMenuUpT from "./components/Menu/ListMenuUpT";
import SideBarHeader from "./components/Header/SideBarHeader";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productList: [],
      fortuneList: [],
      ringTypeList: [],
      categoryList: [],
      colorList: [],
      designInfo: {
        ringId: 0,
        ringSize: null,
        ringSizeMin: null,
        ringSizeMax: null,
        ringColor: "",
        ringPrice: 0,
        ringColorCode: RING_COLOR_DEFAULT
      },
      tmpDesignInfo: {
        ringId: 0,
        ringSize: null,
        ringSizeMin: null,
        ringSizeMax: null,
        ringColor: "",
        ringPrice: 0,
        ringColorCode: RING_COLOR_DEFAULT
      },
      tmpListItem: [],
      dataStoneItem: {},
      idMaterialActive: 1,
      isResetDesign: false,
      isSaveForTab: false,
      isLoadingPage: true,
      isSaveSuccess: false,
      isKeepData: false,
      isShowPopupSp: false,
      isLoadingDrawTool: false,
      isGetParamProduct: false, // take or don't check param product on url
      isCompleteEditDesign: false,
      isCompleteCategoryList: false, // take or don't check param product on url
      isCompleteProductList: false,
      isCompleteFortuneList: false,
      isCompleteRingTypeList: false,
      isCompleteColorList: false,
      idCategoryActive: 0, // id category default
      objSize: {}, // objSize of product select
      paramUrl: {
        productId: null,
        productSizeId: null,
        categoryId: null,
        orderMadeId: null,
        session: null,
        siteFrom: null,
        cartId: null,
        parentId: null,
        sessionUpT: null,
        loginType: null,
      },

      // Orientation
      isOrientation: false,
      orientationW: window.innerWidth,

      // Dialog
      isShowDialogConfirmSave: false,
      isShowDialogMessage: false,
      isShowDialogConfirmTab: false,
      isUpdateMaterialsTray: true,
      isShowDialogConfirmDelete: false,
      isShowDialogConfirmKeepDesign: false,
      dialogMessage: "",

      //Ring type tab
      ringIdActive: ID_RING_TYPE_DEFAULT,


      tmpRingIdActive: 0,
      ringIdClick: ID_RING_TYPE_DEFAULT,

      // Modal
      isShowModalRingList: false,
      isShowModalCategoryList: false,
      isShowModalFortuneList: false,
      isShowModalColorList: false,
      isShowModalSelectSize: false,
      isShowModalListDesign: false,
      isShowModalMaterial: false,
      isShowModalTutorial: true,
      isShowModalConfirmSelectNewStone: false,
      isShowModalLimitDesign: false,
      isShowHamburger: false,
      typeNextAction: null,

      isControlLoadingPage: false,

      // Function
      getWidthBrowser: () => this.getWidthBrowser(),
      getHeightBrowser: () => this.getHeightBrowser(),
      handleUpdate100Vh: () => this.handleUpdate100Vh(),
      handleCloseDialog: dialogName => this.handleCloseDialog(dialogName),
      handleSetDialogMessage: message => this.handleSetDialogMessage(message),
      handleUpdateState: (stateName, stateValue) =>
        this.handleUpdateState(stateName, stateValue)
    };
  }

  componentWillMount() { //function run first
    const urlParams = new URLSearchParams(window.location.search);
    this.setState({
      paramUrl: {
        productId: urlParams.get('product_id'),
        productSizeId: urlParams.get('product_size_id'),
        categoryId: urlParams.get('category_id'),
        orderMadeId: urlParams.get('order_made_id'),
        session: urlParams.get('session_order_made'),
        siteFrom: urlParams.get('site_from'),
        cartId: urlParams.get('cart_id'),
        parentId: urlParams.get('parent_id'),
        sessionUpT: urlParams.get('session'),
        loginType: urlParams.get('login_type'),
      }
    });

    window.addEventListener('message', function (event) {
      if (event.origin === URL_SERVER) {
        let payload = JSON.parse(event.data);
        switch (payload.method) {
          case 'set':
            // localStorage.setItem(payload.key, JSON.stringify(payload.data));
            let itemStorage = payload.data;
            let objLocalStorage = JSON.parse(localStorage.getItem(payload.key)) || [];

            let indexMaterials = objLocalStorage.findIndex(
              item => item.product_id == String(itemStorage.product_id) && item.product_size_id == String(itemStorage.product_size_id)
            );
            if (indexMaterials === -1) {
              objLocalStorage.push(itemStorage);
              localStorage.setItem(payload.key, JSON.stringify(objLocalStorage));
            }
            break;
          case 'get':
            let parent = window.parent;
            let data = localStorage.getItem(payload.key);
            parent.postMessage(data, "*");
            break;
          case 'remove':
            localStorage.removeItem(payload.key);
            break;
        }
      }
    });

    window.addEventListener("storage", (e) => {
      this.localStorageGetItemStone()
      localStorage.removeItem("storage");
    });
    this.localStorageGetItemStone()

    if (localStorage.getItem('storage') != null
        || localStorage.getItem('materials') != null
        || this.state.paramUrl.orderMadeId != null
        || localStorage.getItem('products') != null) {
      this.setState({
        isShowModalTutorial: false,
      })
    }
  }

  componentDidMount() {
    // Fetch api
    this.fetchProductList();
    this.fetchFortuneList();
    this.fetchRingTypeList();
    this.fetchCategoryList();
    this.fetchColorList();

    let elmMain = document.getElementById("main-content");

    if (
      (this.getWidthBrowser() / this.getHeightBrowser() >= 2 &&
        this.getWidthBrowser() < MAX_WIDTH_SP) ||
      768 > this.getWidthBrowser()
    ) {
      if (window.orientation === 0) {
        elmMain.classList.remove("orientation_horizontal");
      } else {
        elmMain.classList.add("orientation_horizontal");
      }
    }

    let isOnIOS =
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPhone/i);
    let eventName = isOnIOS ? "pagehide" : "beforeunload";

    window.addEventListener(eventName, () => {
      // localStorage.removeItem("materials");
      this.setState({ isUpdateMaterialsTray: true });
    });

    window.addEventListener(
      "orientationchange",
      () => {
        this.setState({ isLoadingDrawTool: true });
        window.scrollTo(0, 0);

        setTimeout(() => {
          // if (768 > this.getWidthBrowser()) {
          if (
            (this.getWidthBrowser() / this.getHeightBrowser() >= 2 &&
              this.getWidthBrowser() < MAX_WIDTH_SP) ||
            768 > this.getWidthBrowser()
          ) {
            if (window.orientation === 0) {
              elmMain.classList.remove("orientation_horizontal");
            } else {
              elmMain.classList.add("orientation_horizontal");
            }
          }

          this.setState({
            isOrientation: !this.state.isOrientation,
            isLoadingDrawTool: true
          });
        }, 300);
      },
      false
    );


    //- Fix 100vh
    this.handleUpdate100Vh();

  }

  componentDidUpdate(prevProps, prevState) {
    let { productList, ringTypeList, ringIdActive, isOrientation } = this.state;

    if (prevState.productList !== productList && productList !== []) {
      let tmpMaterials = JSON.parse(localStorage.getItem("materials")) || [];

      let materials = tmpMaterials.filter(obj => {
        let indexItem = findIndex(productList, item => obj.id === item.id);

        if (indexItem !== -1) {
          obj.name = productList[indexItem].name;
          obj.image = productList[indexItem].image_design;
          return true;
        }else{
          return false;
        }
      });
      localStorage.setItem("materials", JSON.stringify(materials));
    }

    //- Check first load browser set ring default
    if (
      prevState.ringTypeList.length === 0 &&
      prevState.ringTypeList !== ringTypeList
    ) {
      let indexItem = findIndex(ringTypeList, item => item.id === ringIdActive);

      if (indexItem !== -1) {
        let valueMaxMin=DesignTool.getMinMaxSizeFromListItem(ringTypeList[indexItem],ringIdActive);
        this.handleUpdateState("designInfo", {
          ringId: ringTypeList[indexItem].rings[0].id,
          ringSize: valueMaxMin.ringSizeMin,
          ringSizeMin: valueMaxMin.ringSizeMin,
          ringSizeMax: valueMaxMin.ringSizeMax,
          ringColor: ringTypeList[indexItem].rings[0].colors[0].color_name,
          ringPrice: ringTypeList[indexItem].rings[0].price,
          ringColorCode: ringTypeList[indexItem].rings[0].colors[0].color_code
        });
        DesignTool.changeView(ringIdActive, {
          size: ringTypeList[indexItem].rings[0].sizes[0].size,
          sizeMin:valueMaxMin.ringSizeMin,
          sizeMax:valueMaxMin.ringSizeMax,
          color: ringTypeList[indexItem].rings[0].colors[0].color_code
        });
        this.handleUpdateState("isLoadingDrawTool", false);

      }
    }

    // Check Orientation
    if (prevState.isOrientation !== isOrientation) {
      this.setState({
        orientationW: window.innerHeight,
        isShowModalRingList: false,
        isShowModalCategoryList: false,
        isShowModalFortuneList: false,
        isShowModalColorList: false,
        isShowPopupSp: false
      });
    }

    this.handleUpdate100Vh();

    if ((this.state.isGetParamProduct || Object.getOwnPropertyNames(this.state.objSize).length > 0)
      && this.state.paramUrl.categoryId == null && this.state.paramUrl.productId != null) {
      this.setProductInBox();
    }
    if (this.state.isGetParamProduct && this.state.isCompleteCategoryList && this.state.paramUrl.categoryId != null) {
      this.showProductModal();
    }

    if(this.state.isCompleteCategoryList
        && this.state.isCompleteProductList
        && this.state.isCompleteFortuneList
        && this.state.isCompleteColorList
        && this.state.isLoadingPage
        && this.state.paramUrl.orderMadeId == null
        && this.state.isControlLoadingPage == false
    ){
      this.setState({
        isLoadingPage: false,
      })
    }

    if(this.state.paramUrl.orderMadeId
        && this.state.productList !== []
        && !this.state.isCompleteEditDesign
        && this.state.isCompleteCategoryList
        && this.state.isCompleteProductList
        && this.state.isCompleteFortuneList
        && this.state.isCompleteColorList
        && this.state.isLoadingPage){
      this.setState({
        isCompleteEditDesign: true,
        isLoadingPage: true,
      })
      const url = URL_API + "/design/" + this.state.paramUrl.orderMadeId+ "?session=" + this.state.paramUrl.session;
      fetch(url, {
        method: "GET"
      })
          .then(response => response.json())
          .then(data =>
              // console.log(data.data),
              this.handleUpdateDesign(data.data),
          )
          .catch(() =>
              console.log("Can’t access " + url + " response. Blocked by browser?")
          );
    }

  }

  handleUpdate100Vh() {
    //- First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    //- Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  }

  // Fetch list all product
  fetchProductList() {
    const url = URL_API + "/products";
    fetch(url, {
      method: "GET"
    })
      .then(response => response.json())
      .then(data =>
        this.setState({
          productList: data.data || [],
          isCompleteProductList: true,
          isGetParamProduct: true
        })
      )
      .catch(() =>
        console.log("Can’t access " + url + " response. Blocked by browser?")
      );
  }

  // Fetch list all fortune
  fetchFortuneList() {
    const url = URL_API + "/fortunes";
    fetch(url, {
      method: "GET"
    })
      .then(response => response.json())
      .then(dataResponse =>
        this.setState({
          fortuneList: dataResponse.data || [],
          isCompleteFortuneList: true
        })
      )
      .catch(() =>
        console.log("Can’t access " + url + " response. Blocked by browser?")
      );
  }

  // Fetch list all ring type
  fetchRingTypeList() {
    const url = URL_API + "/rings";
    fetch(url, {
      method: "GET"
    })
      .then(response => response.json())
      .then(data =>
        this.setState({
          ringTypeList: data.data || [],
          isCompleteRingTypeList: true
        })
      )
      .catch(() =>
        console.log("Can’t access " + url + " response. Blocked by browser?")
      );
  }

  // fetch list all category
  fetchCategoryList() {
    const url = URL_API + "/categories";
    fetch(url, {
      method: "GET"
    })
      .then(response => response.json())
      .then(dataResponse =>
        this.setState({
          categoryList: dataResponse.data || [],
          isCompleteCategoryList: true,
        })
      )
      .catch(() =>
        console.log("Can’t access " + url + " response. Blocked by browser?")
      );
  }

  // fetch list color
  fetchColorList() {
    const url = URL_API + "/colors";
    fetch(url, {
      method: "GET"
    })
      .then(response => response.json())
      .then(dataResponse =>
        this.setState({
          colorList: dataResponse.data || [],
          isCompleteColorList: true
        })
      )
      .catch(() =>
        console.log("Can’t access " + url + " response. Blocked by browser?")
      );
  }

  handleCloseDialog(dialogName) {
    this.setState({ [dialogName]: false });
  }

  handleSetDialogMessage(message) {
    this.setState({ dialogMessage: message });
  }

  handleUpdateState(stateName, stateValue) {
    this.setState({ [stateName]: stateValue });
  }

  handleUpdateDesign(design) {
    let { productList } = this.state;
    let items = design.items;
    let tmpMaterial = [];
    // check material edit design update materials-tray
    localStorage.removeItem("materials");
    this.setState({ isUpdateMaterialsTray: true }, () => {
      // check material edit design
      items.map(item => {
        let indexItem = findIndex(
          productList,
          proj => proj.id === item.productID
        );

        if (indexItem !== -1) {
          let material = {
            id: productList[indexItem].id,
            name: productList[indexItem].name,
            image: productList[indexItem].image_design,
            fortunes: productList[indexItem].fortunes,
            type: productList[indexItem].type
          };
          let indexSize = findIndex(
            productList[indexItem].sizes,
            size => size.id === item.sizeID
          );

          if (indexSize !== -1) {
            material.sizes = productList[indexItem].sizes[indexSize];
            material.objSize = {
              width: item.imageSize,
              height: item.img.height
            };

            tmpMaterial.push(material);
          }
        }
      });

      localStorage.setItem(
        "materials",
        JSON.stringify(uniqBy(tmpMaterial, "sizes"))
      );
      this.setState({ isUpdateMaterialsTray: true });
    });

    this.setState(
      {
        ringIdActive: design.ringTypeId,
        designInfo: {
          ringId: design.ringId,
          ringSize: design.ringSize,
          ringSizeMin: DesignTool.getSizeDesignMin(design),
          ringSizeMax: DesignTool.getSizeDesignMax(design),
          ringColor: design.ringColor,
          ringPrice: design.ringPrice,
          ringColorCode: design.ringColorCode
        }
      },
      () => {
        // Update design tool
        DesignTool.initializeDesign(
          design.ringTypeId,
          document.getElementById("wrap_draw_tool"),
          {
            size: design.ringSize,
            color: design.ringColorCode
          },
          design
        );
        if (items.length > 0) {
          for (var i = 0; i < items.length; i++) {
            let index = findIndex(
              productList,
              item => item.id === items[i].productID
            );
            let hookPos = null;

            if (index !== -1 && items[i].productType === CHARM_TYPE) {
              hookPos = {
                hookW: productList[index].charm_hanger_width,
                hookX: productList[index].charm_hanger_coord_x,
                hookY: productList[index].charm_hanger_coord_y
              };
            }

            // update url image
            let n = items[i].imageURL.search(/t=/i);
            let urlImage = "";

            if (n !== -1) {
              urlImage =
                items[i].imageURL.slice(0, n + 2) + `${new Date().getTime()}`;
            } else {
              urlImage = items[i].imageURL + `?t=${new Date().getTime()}`;
            }

            DesignTool.addItem(
              design.ringTypeId,
              items[i].angle,
              items[i].sizeID,
              urlImage,
              items[i].imageSize,
              items[i].size,
              items[i].productID,
              items[i].productType,
              hookPos
            );
          }
        }
      }
    );
    this.setState({ isLoadingPage: false });
  }

  getWidthBrowser() {
    let width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;

    return width;
  }

  getHeightBrowser() {
    let height =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;

    return height;
  }

  // close all tabs SP
  handleCloseAllTabs() {
    this.setState({
      isShowModalFortuneList: false,
      isShowModalColorList: false,
      isShowModalMaterial: false,
      isShowModalRingList: false,
      isShowPopupSp: false
    });
  }

  setProductInBox() {//function show product in box
    let focusProduct = this.getProductDetailOfParamUrl();
    if (Object.getOwnPropertyNames(focusProduct.productSizeDetail).length > 0) {
      let item = focusProduct.productDetail;
      let sizes = focusProduct.productSizeDetail;
      let itemStorage = {
        id: item.id,
        name: item.name,
        image: item.image_design,
        fortunes: item.fortunes,
        sizes: sizes,
        type: item.type
      };


      if (Object.getOwnPropertyNames(this.state.objSize).length == 0) {
        this.getMetaImg(`${URL_IMG}${item.image_design}`);
      }

      if (Object.getOwnPropertyNames(this.state.objSize).length > 0) {
        let materials = JSON.parse(localStorage.getItem("materials")) || [];

        itemStorage.objSize = this.state.objSize;
        let indexMaterials = materials.findIndex(
          item => item.id == String(itemStorage.id) && item.sizes.id === sizes.id
        );
        if (indexMaterials === -1) {
          materials.push(itemStorage);
          localStorage.setItem("materials", JSON.stringify(materials));
          this.handleCheckSize(item.sizes);
          this.handleUpdateState("isUpdateMaterialsTray", true);
        }
        this.setState({
          objSize: {}
        })

      }
    }

    this.setState({
      isGetParamProduct: false
    })

  }

  getMetaImg(url) {
    let img = new Image(url);

    img.src = url;
    img.onload = () => this.setState({
      objSize: {
        height: img.naturalHeight,
        width: img.naturalWidth
      }
    })
  };

  handleCheckSize(sizes) {
    let sizeDefault = 8;
    let materials = JSON.parse(localStorage.getItem("materials")) || [];
    sizes.map(item => {
      if (item.type === CHARM_TYPE) {
        item.height = (item.size + 10) * 3;
      } else {
        item.height =
          (item.size > 12 ? 12 + (item.size * 3) / 100 : item.size) *
          sizeDefault;
      }

      let indexItem = findIndex(
        materials,
        material =>
          material.sizes.id === item.id && material.sizes.size === item.size
      );

      if (indexItem !== -1) {
        item.selected = true;
      } else {
        item.selected = false;
      }
    });
  }

  showProductModal() {
    let focusProduct = this.getProductDetailOfParamUrl();

    if (Object.getOwnPropertyNames(focusProduct.productSizeDetail).length > 0 && focusProduct.indexCategory != -1) {
      this.setState({
        idMaterialActive: 2,
        idCategoryActive: focusProduct.indexCategory,
        isShowModalMaterial: true,
        dataStoneItem: focusProduct.productDetail,
        isShowModalSelectSize: true
      })
    } else { // if empty focus product size show modal introduce tutorial
      this.setState({
        isShowModalTutorial: true,
      })
    }
    this.setState({
      isGetParamProduct: false
    })
  }

  getProductDetailOfParamUrl() { // function return product, product size
    let { categoryId, productId, productSizeId } = this.state.paramUrl;
    let { productList, categoryList } = this.state;
    let productDetail = {};
    let productSizeDetail = {};
    let indexSize = -1;
    let index = findIndex(
      productList,
      item => item.slug == String(productId)
    );
    let indexCategory = findIndex(
      categoryList,
      item => item.id === Number(categoryId)
    );

    if (index !== -1) {
      productDetail = productList[index];
      indexSize = findIndex(
        productDetail.sizes,
        item => item.sku == String(productSizeId)
      );
      if (indexSize != -1) {
        productSizeDetail = productList[index].sizes[indexSize];
      }
    }

    return {
      productDetail: productDetail,
      productSizeDetail: productSizeDetail,
      indexCategory: indexCategory,
    }
  }

  localStorageGetItemStone() {
    if (localStorage.getItem('storage')) {
      let objLocalStorage = JSON.parse(localStorage.getItem('storage'));

      objLocalStorage.forEach(data => {
        this.setState({
          paramUrl: {
            productId: data.product_id,
            productSizeId: data.product_size_id,
          }
        });
        this.setProductInBox();
      });
      // localStorage.removeItem('storage');
    }
  }
  render() {
    let {
      isShowModalCategoryList,
      isShowDialogConfirmSave,
      isShowModalFortuneList,
      isShowModalSelectSize,
      isShowModalListDesign,
      isShowModalColorList,
      isShowModalMaterial,
      isShowModalTutorial,
      isShowModalRingList,
      isLoadingPage,
      isShowPopupSp,
      isShowModalConfirmSelectNewStone,
      isShowModalLimitDesign,
      isShowHamburger
    } = this.state;

    return (
      <Fragment>
        <Header {...this.state} />
        <Menu {...this.state} />
        <Content {...this.state} />
        {/* Show mobile */}
        <div className={`show_sp ${isShowPopupSp ? "is_show" : ""}`}>
          <button
            className="close_tab"
            onClick={() => this.handleCloseAllTabs()}
          >
            <img src="/img/icon_close_new.png" alt="arrow down" />
            {/*<span>閉じる</span>*/}
          </button>
          <div className="prd_infor_wrap">
            <CartTotals {...this.state} />
            <ButtonPurchase {...this.state} typeButtonSave = {TYPE_NEXT_SAVE} />
          </div>
          <MaterialsTray {...this.state} />
          <div className="footer_sp" id="footer_sp">
            <span>素材一覧</span>
            <ListMenu {...this.state} />
          </div>

          {/* Modal */}
          {isShowModalRingList ? (
            <ModalRingList
              {...this.state}
              handleCloseAllTabs={() => this.handleCloseAllTabs()}
            />
          ) : null}
          {isShowModalColorList ? <ModalColorList {...this.state} /> : null}
          {isShowModalFortuneList ? <ModalFortuneList {...this.state} /> : null}
          {isShowModalCategoryList ? (
            <ModalCategoryList {...this.state} />
          ) : null}
        </div>

        <SideBarHeader {...this.state} />

        <ListMenuUpT {...this.state} />

        {/* Image move */}
        <div className="img_move">
          <img id="img_move" src="" alt="" />
        </div>

        {/* Modal */}
        {isShowModalMaterial && this.getWidthBrowser() >= MAX_WIDTH_SP ? (
          <ModalMaterial {...this.state} />
        ) : null}
        {isShowModalListDesign ? (
          <ModalListDesign
            handleUpdateDesign={data => this.handleUpdateDesign(data)}
            {...this.state}
          />
        ) : null}
        {isShowModalSelectSize ? <ModalSelectSize {...this.state} /> : null}
        <ModalTutorial
          isShowModalTutorial={isShowModalTutorial}
          handleUpdateState={(stateName, stateValue) =>
            this.handleUpdateState(stateName, stateValue)
          }
          {...this.state}
        />
        {isShowModalConfirmSelectNewStone ? <ModalConfirmSelectNewStone {...this.state} /> : null}

        {/* Dialog */}
        <DialogMessage {...this.state} />
        {isShowDialogConfirmSave ? <DialogConfirmSave {...this.state} /> : null}
        <DialogConfirmTab {...this.state} />
        <DialogConfirmKeepDesign {...this.state} />

        {/* Loading */}
        {isLoadingPage ? (
          <div className="loading">
            <img src="/img/icon-loading.gif" alt="" />
          </div>
        ) : null}
      </Fragment>
    );
  }
}

export default App;
